const unpaid_date = (note) => {
  const dates = [
    note.unpaid_date1,
    note.unpaid_date2,
    note.unpaid_date3,
    note.unpaid_date4,
  ].filter((date) => date !== undefined);
  return dates.length > 0
    ? `Неоплаченное время отдыха за: ${dates.join(", ")}`
    : "";
};

export default unpaid_date;
